import React, { useState } from 'react';

const CovenantMarriage = ({ formData, updateFormData, nextStep, prevStep }) => {
  const [showDeclaration, setShowDeclaration] = useState(false);

  const handleAnswer = (answer) => {
    if (answer === true) {
      // Show the declaration statement
      setShowDeclaration(true);
      updateFormData({ isCovenantMarriage: answer });
    } else {
      // No was selected, proceed directly
      updateFormData({ isCovenantMarriage: answer });
      nextStep();
    }
  };

  const handleDeclarationNext = () => {
    nextStep();
  };

  if (showDeclaration) {
    return (
      <div className="question-screen">
        <h1 className="question-title">COVENANT MARRIAGE DECLARATION</h1>

        <div className="question-content">
          <p className="question-prompt">
            Please read the statement below and click next.
          </p>

          <div className="declaration-panel">
            <p>
              We, <strong>
                {formData.partyA?.firstName} {formData.partyA?.lastName}
                {formData.partyA?.suffix && formData.partyA.suffix !== '' ? ` ${formData.partyA.suffix}` : ''}
              </strong> and{' '}
              <strong>
                {formData.partyB?.firstName} {formData.partyB?.lastName}
                {formData.partyB?.suffix && formData.partyB.suffix !== '' ? ` ${formData.partyB.suffix}` : ''}
              </strong> do hereby declare our
              intent to contract a Covenant Marriage and, accordingly, have executed a declaration of intent
              attached hereto.
            </p>
          </div>
        </div>

        <div className="step-navigation">
          <button onClick={() => setShowDeclaration(false)} className="btn btn-secondary">Back</button>
          <button onClick={handleDeclarationNext} className="btn btn-primary">Next</button>
        </div>
      </div>
    );
  }

  return (
    <div className="question-screen">
      <button onClick={prevStep} className="btn btn-secondary question-back-button">
        Back to Previous Question
      </button>

      <h1 className="question-title">COVENANT MARRIAGE</h1>
      <p className="question-subtitle">La. R.S. 9:272 et seq</p>

      <div className="question-content">
        <h4>Do both parties wish to declare this a Covenant Marriage as defined by La. R.S. 9:272 et seq?</h4>

        <h4 className="question-section-heading">La. R.S. 9:272</h4>

        <p>
          <strong>A.</strong> A covenant marriage is a marriage entered into by one male and one female who
          understand and agree that the marriage between them is a lifelong relationship. Parties to a covenant
          marriage have received counseling emphasizing the nature and purposes of marriage and the responsibilities
          thereto. Only when there has been a complete and total breach of the marital covenant commitment may the
          non-breaching party seek a declaration that the marriage is no longer legally recognized.
        </p>

        <p>
          <strong>B.</strong> A man and woman may contract a covenant marriage by declaring their intent to do so
          on their application for a marriage license, as provided in R.S. 9:224(C), and executing a declaration
          of intent to contract a covenant marriage, as provided in R.S. 9:273. The application for a marriage
          license and the declaration of intent shall be filed with the official who issues the marriage license.
        </p>

        <p>
          <strong>C.</strong> A covenant marriage terminates only for one of the causes enumerated in Civil Code
          Article 101. A covenant marriage may be terminated by divorce only upon one of the exclusive grounds
          enumerated in R.S. 9:307. A covenant marriage agreement may not be dissolved, rescinded, or otherwise
          terminated by the mutual consent of the spouses.
        </p>

        <div className="supporting-documents-panel">
          <p className="supporting-documents-title">
            You will need the following two documents prepared when you obtain your marriage license:
          </p>
          <ul>
            <li>Declaration of Intent</li>
            <li>Affidavit with Attestation of Counselor</li>
          </ul>
          <p className="question-note">
            The forms are available below. They must be executed before a Notary Public.
          </p>
          <p className="question-link-row">
            <a
              href={`${process.env.PUBLIC_URL}/forms/covenant-marriage-form.pdf`}
              target="_blank"
              rel="noopener noreferrer"
              className="question-document-link"
            >
              Covenant Marriage Forms
            </a>
          </p>
        </div>

        <p className="question-prompt">
          Do both parties wish to declare this a Covenant Marriage?
        </p>
      </div>

      <div className="question-buttons">
        <button onClick={() => handleAnswer(true)} className="question-btn yes">Yes</button>
        <button onClick={() => handleAnswer(false)} className="question-btn no">No</button>
      </div>
    </div>
  );
};

export default CovenantMarriage;
